function normalizeEnvValue(value?: string) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : "";
}

function getDefaultApiBaseUrl() {
  const configured = normalizeEnvValue(process.env.REACT_APP_API_BASE_URL);
  if (configured) return configured;
  return process.env.NODE_ENV === "production" ? "/api" : "http://localhost:8000";
}

export const GOOGLE_OAUTH_POPUP_COMPLETE_PATH = "/google-link/complete";
export const NEWS_GOOGLE_RECONSENT_COMPLETE_PATH = "/news/google-consent/complete";
export const LINE_OAUTH_POPUP_COMPLETE_PATH = "/line-link/complete";

function buildSameOriginUrl(pathname: string) {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${pathname}`;
  }

  return pathname;
}

export function resolveGoogleOAuthPopupCompleteUrl(pathname = GOOGLE_OAUTH_POPUP_COMPLETE_PATH) {
  return buildSameOriginUrl(pathname);
}

export function resolveNewsGoogleReconsentCompleteUrl(pathname = NEWS_GOOGLE_RECONSENT_COMPLETE_PATH) {
  return buildSameOriginUrl(pathname);
}

export function resolveLineOAuthPopupCompleteUrl(pathname = LINE_OAUTH_POPUP_COMPLETE_PATH) {
  return buildSameOriginUrl(pathname);
}

export const API_BASE_URL = getDefaultApiBaseUrl();
export const API_KEY = normalizeEnvValue(process.env.REACT_APP_API_KEY);
export const LINE_OFFICIAL_ACCOUNT_URL = normalizeEnvValue(process.env.REACT_APP_LINE_OFFICIAL_ACCOUNT_URL);
export const GOOGLE_CLIENT_ID = normalizeEnvValue(process.env.REACT_APP_GOOGLE_CLIENT_ID);
export const GOOGLE_SSO_BYPASS = process.env.REACT_APP_GOOGLE_SSO_BYPASS === "true";
